import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

interface User {
  id: string;
  email: string;
  role: string;
}

interface HeaderProps {
  user: User;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ user, onLogout }) => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left">
          <Link to="/dashboard" className="logo">
            <h1>Practice Platform</h1>
          </Link>
        </div>
        
        <nav className="header-nav">
          <Link to="/dashboard" className="nav-link">
            Dashboard
          </Link>
          
          {user.role === 'admin' && (
            <Link to="/admin" className="nav-link">
              Admin
            </Link>
          )}
        </nav>
        
        <div className="header-right">
          <div className="user-info">
            <span className="user-email">{user.email}</span>
            <span className="user-role">{user.role}</span>
          </div>
          <button onClick={onLogout} className="logout-btn">
            Logout
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
